<template>
    <div>
        <div class="row">
            <div class="col-md-8">
                <div class="card  abtg__default-card abtg__orangeborder-bottom ">
                    <div class="card-head">
                        <header>Cerca corsista</header>
                    </div>
                    <div class="card-body ">
                        <form @submit.prevent="searchUser()">
                            <div class="row">
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="searchText"
                                        >
                                        <label class="mdl-textfield__label">Email corsista</label>

                                    </div>
                                    <button class="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect margin-right-10 btn-success float-right">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-8">
                <div class="card  abtg__default-card abtg__orangeborder-bottom ">
                    <div class="card-head">
                        <header>Risultato</header>
                    </div>
                    <div class="card-body ">
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive">
                                    <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                                        <thead>
                                        <tr>
                                            <th class="mdl-data-table__cell--non-numeric text-left">
                                                Email
                                            </th>


                                            <th class="mdl-data-table__cell--non-numeric text-left">
                                                Iscritto dal
                                            </th>
                                            <th class="mdl-data-table__cell--non-numeric text-left">
                                                Operazioni
                                            </th>

                                            <th class="mdl-data-table__cell--non-numeric text-left">

                                            </th>


                                        </tr>
                                        </thead>
                                        <tbody>


                                        <tr v-for="(u, index) in content.userList">
                                            <td>
                                                {{u.email}}
                                            </td>

                                            <td>
                                                {{u.created_at}}
                                            </td>

                                            <td>
                                                {{u.totalIncome}}

                                            </td>
                                            <td>
                                                <a href="#" @click="openModal(u.id)"><i class="fas fa-eye"></i></a>
                                            </td>
                                        </tr>


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>


    export default {
        mixins: [],
        props: ['content'],
        components: {},
        data: function () {
            return {
                searchText: '',
                showDetail: false,
            }
        },

        computed: {},
        created: function () {
        },
        methods: {
            searchUser: function () {
                this.$emit('send-user', this.searchText)
            },

            openModal: function (id) {
                this.$emit('open-modal', id);
            }

        }
    }
</script>